(function () {
  const formatMoney = (cents, moneyFormat = window?.Shopify?.money_format || '{{amount}} €') => {
    const value = (Number(cents) || 0) / 100;
    const formatted = value.toLocaleString('nl-NL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return moneyFormat
      .replace('{{amount}}', formatted)
      .replace('{{ amount }}', formatted)
      .replace('{{amount_with_comma_separator}}', formatted)
      .replace('{{ amount_with_comma_separator }}', formatted)
      .replace('{{amount_no_decimals}}', Math.round(value).toString())
      .replace('{{ amount_no_decimals }}', Math.round(value).toString());
  };

  const priceState = {
    mode: localStorage.getItem('pe-price-mode') || 'incl'
  };

  const refreshJudgeMe = () => {
    if (window.jdgm && typeof window.jdgm.loadBadge === 'function') window.jdgm.loadBadge();
    if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') window.jdgm.loadWidgets();
  };

  const setToggleButtons = (mode) => {
    document.querySelectorAll('[data-price-toggle]').forEach((toggle) => {
      toggle.querySelectorAll('button[data-value]').forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.value === mode);
      });
    });
  };

  const applyPriceMode = (root = document) => {
    const mode = priceState.mode;

    root.querySelectorAll('[data-pe-price-box]').forEach((box) => {
      const vatRate = Number(box.dataset.vatRate || 21);

      const saleEl = box.querySelector('[data-pe-sale-price]');
      const compareEl = box.querySelector('[data-pe-compare-price]');
      const compareRow = box.querySelector('[data-pe-adviesprijs-row]');
      const saleLabelEl = box.querySelector('[data-pe-sale-label]');
      const saveLabelEl = box.querySelector('[data-pe-saving]');

      if (saleEl) {
        const incl = Number(saleEl.dataset.priceIncl || 0);
        const excl = Math.round(incl / (1 + vatRate / 100));
        saleEl.textContent = formatMoney(mode === 'excl' ? excl : incl);
      }

      if (saveLabelEl) {
        const incl = Number(saveLabelEl.dataset.priceIncl || 0);
        const excl = Math.round(incl / (1 + vatRate / 100));
        saveLabelEl.textContent = 'Bespaar ' + formatMoney(mode === 'excl' ? excl : incl);
      }

      if (compareEl && compareRow) {
        const inclCompare = Number(compareEl.dataset.priceIncl || 0);

        if (inclCompare > 0) {
          const exclCompare = Math.round(inclCompare / (1 + vatRate / 100));
          compareEl.textContent = formatMoney(mode === 'excl' ? exclCompare : inclCompare);
          compareRow.hidden = false;
        } else {
          compareEl.textContent = '';
          compareRow.hidden = true;
        }
      }

      if (saleLabelEl) {
        saleLabelEl.textContent =
          mode === 'excl'
            ? (saleLabelEl.dataset.labelExcl || 'Prijs excl. btw')
            : (saleLabelEl.dataset.labelIncl || 'Prijs incl. btw');
      }
    });

    document.querySelectorAll('[data-pe-sticky-sale-price]').forEach((el) => {
      const vatRate = Number(el.dataset.vatRate || 21);
      const incl = Number(el.dataset.priceIncl || 0);
      const excl = Math.round(incl / (1 + vatRate / 100));
      el.textContent = formatMoney(mode === 'excl' ? excl : incl);
    });

    setToggleButtons(mode);
  };

  const syncVariantUI = (section, variant) => {
    if (!section || !variant) return;

    const saleEl = section.querySelector('[data-pe-sale-price]');
    const compareEl = section.querySelector('[data-pe-compare-price]');
    const compareRow = section.querySelector('[data-pe-adviesprijs-row]');
    const skuEl = section.querySelector('[data-pe-sku]');
    const skuWrap = section.querySelector('[data-pe-sku-wrapper]');
    const stickySaleEl = document.querySelector('[data-pe-sticky-sale-price]');
    const gallery = section.querySelector('[data-pe-gallery]');

    if (saleEl) {
      saleEl.dataset.priceIncl = variant.price || 0;
    }

    if (stickySaleEl) {
      stickySaleEl.dataset.priceIncl = variant.price || 0;
    }

    if (compareEl && compareRow) {
      const compareAt = Number(variant.compare_at_price || 0);
      const price = Number(variant.price || 0);
      const hasCompare = compareAt > price;

      compareEl.dataset.priceIncl = hasCompare ? String(compareAt) : '0';
      compareRow.hidden = !hasCompare;

      if (!hasCompare) {
        compareEl.textContent = '';
      }
    }

    if (skuEl && skuWrap) {
      if (variant.sku) {
        skuEl.textContent = variant.sku;
        skuWrap.hidden = false;
      } else {
        skuWrap.hidden = true;
      }
    }

    if (
      gallery &&
      variant.featured_media_id &&
      typeof gallery.showMedia === 'function'
    ) {
      gallery.showMedia(variant.featured_media_id);
    }

    applyPriceMode(section);
    refreshJudgeMe();

    if (window.peStickyFooterController) {
      window.peStickyFooterController.refresh();
    }
  };

  const bindProductSections = (root = document) => {
    root.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.peBound === 'true') return;
      section.dataset.peBound = 'true';

      const variantPricingEl = section.querySelector('[data-pe-variant-pricing]');
      if (!variantPricingEl) return;

      let variantPricingData = null;
      try {
        variantPricingData = JSON.parse(variantPricingEl.textContent);
      } catch {
        return;
      }

      const variants = Array.isArray(variantPricingData.variants) ? variantPricingData.variants : [];

      const getVariantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const getCurrentVariant = () => {
        const variantInput = section.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (variantInput && variantInput.value) {
          const found = getVariantById(variantInput.value);
          if (found) return found;
        }
        return variants[0] || null;
      };

      const update = () => {
        const variant = getCurrentVariant();
        syncVariantUI(section, variant);
      };

      update();

      const form = section.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('change', () => setTimeout(update, 80));
      }

      const variantInput = section.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (variantInput) {
        variantInput.addEventListener('change', update);
      }
    });
  };

  const bindPriceToggle = () => {
    document.querySelectorAll('[data-price-toggle]').forEach((toggle) => {
      if (toggle.dataset.peBound === 'true') return;
      toggle.dataset.peBound = 'true';

      toggle.querySelectorAll('button[data-value]').forEach((button) => {
        button.addEventListener('click', () => {
          priceState.mode = button.dataset.value;
          localStorage.setItem('pe-price-mode', priceState.mode);
          applyPriceMode(document);
        });
      });
    });
  };

  const bindScrollLinks = (root = document) => {
    root.querySelectorAll('[data-scroll-link]').forEach((link) => {
      if (link.dataset.peBound === 'true') return;
      link.dataset.peBound = 'true';

      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href');
        if (!targetId || !targetId.startsWith('#')) return;
        const target = document.querySelector(targetId);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  };

  const bindGallery = (root = document) => {
    root.querySelectorAll('[data-pe-gallery]').forEach((gallery) => {
      if (gallery.dataset.peBound === 'true') return;
      gallery.dataset.peBound = 'true';

      const slides = Array.from(gallery.querySelectorAll('[data-media-id]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-thumb-media-id]'));
      const prevBtn = gallery.querySelector('[data-gallery-prev]');
      const nextBtn = gallery.querySelector('[data-gallery-next]');
      let currentIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));

      const showIndex = (index) => {
        if (!slides.length) return;
        currentIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, idx) => {
          const isActive = idx === currentIndex;
          slide.hidden = !isActive;
          slide.classList.toggle('is-active', isActive);
        });

        thumbs.forEach((thumb, idx) => {
          thumb.classList.toggle('is-active', idx === currentIndex);
        });
      };

      const showMediaById = (mediaId) => {
        const index = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
        if (index >= 0) showIndex(index);
      };

      thumbs.forEach((thumb, idx) => thumb.addEventListener('click', () => showIndex(idx)));
      if (prevBtn) prevBtn.addEventListener('click', () => showIndex(currentIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => showIndex(currentIndex + 1));

      gallery.showMedia = showMediaById;
    });
  };

  const createStickyFooterController = () => {
    const stickyBar = document.querySelector('[data-pe-sticky-bar]');
    if (!stickyBar) return null;

    const getTrigger = () =>
      document.querySelector('[data-pe-sticky-trigger]') ||
      document.querySelector('#pe-buy-box') ||
      document.querySelector('.pe-block--buy') ||
      document.querySelector('.pe-product__info');

    let rafId = null;

    const update = () => {
      const trigger = getTrigger();
      if (!trigger) {
        stickyBar.classList.remove('is-visible');
        return;
      }

      const rect = trigger.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const isInView = rect.top < viewportHeight && rect.bottom > 0;

      stickyBar.classList.toggle('is-visible', !isInView);
    };

    const requestUpdate = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('load', requestUpdate);

    requestUpdate();

    return { refresh: requestUpdate };
  };

  const initAll = (root = document) => {
    bindPriceToggle();
    bindScrollLinks(root);
    bindGallery(root);
    bindProductSections(root);
    applyPriceMode(root);
    refreshJudgeMe();

    if (!window.peStickyFooterController) {
      window.peStickyFooterController = createStickyFooterController();
    } else {
      window.peStickyFooterController.refresh();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  window.addEventListener('load', () => {
    setTimeout(() => initAll(document), 120);
  });

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

(() => {
  'use strict';

  const DESKTOP_QUERY = window.matchMedia(
    '(min-width: 990px)'
  );

  const initializeFollowingBuyColumn = (
    productSection
  ) => {
    if (
      !productSection ||
      productSection.dataset.buyFollowInitialized ===
        'true'
    ) {
      return;
    }

    const column = productSection.querySelector(
      '[data-pe-buy-column]'
    );

    const panel = productSection.querySelector(
      '[data-pe-buy-panel]'
    );

    const productGrid = productSection.querySelector(
      '.pe-product__grid--hero'
    );

    if (!column || !panel || !productGrid) {
      return;
    }

    productSection.dataset.buyFollowInitialized =
      'true';

    let animationFrame = null;

    const resetPanel = () => {
      panel.classList.remove(
        'is-following',
        'is-at-bottom'
      );

      panel.style.removeProperty('left');
      panel.style.removeProperty(
        '--pe-buy-panel-width'
      );

      column.style.removeProperty('min-height');
    };

    const updatePanelPosition = () => {
      animationFrame = null;

      if (!DESKTOP_QUERY.matches) {
        resetPanel();
        return;
      }

      const columnRect =
        column.getBoundingClientRect();

      const gridRect =
        productGrid.getBoundingClientRect();

      const panelHeight = panel.offsetHeight;
      const viewportHeight = window.innerHeight;

      /*
       * Centre the panel vertically in the viewport.
       */
      const desiredTop =
        (viewportHeight - panelHeight) / 2;

      /*
       * The panel cannot be vertically centred properly when
       * it is taller than the available viewport.
       */
      const safeTop = Math.max(20, desiredTop);

      const panelBottomPosition =
        safeTop + panelHeight;

      const shouldFollow =
        gridRect.top < safeTop &&
        gridRect.bottom > panelBottomPosition;

      const reachedBottom =
        gridRect.top < safeTop &&
        gridRect.bottom <= panelBottomPosition;

      /*
       * Preserve the original column dimensions while its
       * child uses position: fixed.
       */
      column.style.minHeight =
        `${panelHeight}px`;

      if (shouldFollow) {
        const currentColumnRect =
          column.getBoundingClientRect();

        panel.classList.add('is-following');
        panel.classList.remove('is-at-bottom');

        panel.style.left =
          `${currentColumnRect.left}px`;

        panel.style.setProperty(
          '--pe-buy-panel-width',
          `${currentColumnRect.width}px`
        );

        if (desiredTop < 20) {
          panel.style.top = '20px';
          panel.style.transform = 'none';
        } else {
          panel.style.top = '50%';
          panel.style.transform =
            'translateY(-50%)';
        }

        return;
      }

      panel.style.removeProperty('left');
      panel.style.removeProperty('top');
      panel.style.removeProperty('transform');
      panel.style.removeProperty('--pe-buy-panel-width');

      if (reachedBottom) {
        panel.classList.remove('is-following');
        panel.classList.add('is-at-bottom');
      } else {
        panel.classList.remove(
          'is-following',
          'is-at-bottom'
        );
      }
    };

    const requestPositionUpdate = () => {
      if (animationFrame !== null) {
        return;
      }

      animationFrame = requestAnimationFrame(
        updatePanelPosition
      );
    };

    window.addEventListener(
      'scroll',
      requestPositionUpdate,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      requestPositionUpdate
    );

    DESKTOP_QUERY.addEventListener?.(
      'change',
      requestPositionUpdate
    );

    /*
     * Recalculate when app blocks, reviews, variants or
     * payment elements change the height of the buy panel.
     */
    const resizeObserver =
      typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(
            requestPositionUpdate
          )
        : null;

    resizeObserver?.observe(panel);
    resizeObserver?.observe(column);

    requestPositionUpdate();

    productSection.peDestroyBuyFollow = () => {
      window.removeEventListener(
        'scroll',
        requestPositionUpdate
      );

      window.removeEventListener(
        'resize',
        requestPositionUpdate
      );

      DESKTOP_QUERY.removeEventListener?.(
        'change',
        requestPositionUpdate
      );

      resizeObserver?.disconnect();

      if (animationFrame !== null) {
        cancelAnimationFrame(animationFrame);
      }

      resetPanel();

      delete productSection.dataset
        .buyFollowInitialized;
    };
  };

  const initializeAllFollowingColumns = (
    root = document
  ) => {
    if (
      root.matches?.('[data-product-section]')
    ) {
      initializeFollowingBuyColumn(root);
    }

    root
      .querySelectorAll?.(
        '[data-product-section]'
      )
      .forEach(
        initializeFollowingBuyColumn
      );
  };

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initializeAllFollowingColumns();
    }
  );

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeAllFollowingColumns(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      const sections = [];

      if (
        event.target.matches?.(
          '[data-product-section]'
        )
      ) {
        sections.push(event.target);
      }

      event.target
        .querySelectorAll?.(
          '[data-product-section]'
        )
        .forEach((section) => {
          sections.push(section);
        });

      sections.forEach((section) => {
        section.peDestroyBuyFollow?.();
      });
    }
  );
})();

